import styled from '@emotion/styled';

import { sizeToStyles } from './CocoSharpText.constants';
import { Props } from './CocoSharpText.types';

export const baseFontStyles = `
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'ss04' on, 'ss09' on;
  font-variation-settings: "opsz" 703;

  @supports (-webkit-overflow-scrolling: touch) {
    font-size-adjust: 0.475;
    word-spacing: -0.065em;
  }
`;

export const sharedStyles = styled('div', {
  shouldForwardProp: (prop) =>
    ![
      'elementType',
      'fontFamily',
      'desktopSize',
      'mobileSize',
      'fontWeight',
      'bold',
      'italic',
    ].includes(prop),
})<Props>`
  font: unset;

  font-family: ${({ fontFamily, italic }) =>
    `'${italic ? 'Coco Sharp Italic' : fontFamily || 'Coco Sharp'}',
    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`};
  font-weight: ${({ fontWeight, bold }) =>
    fontWeight !== undefined ? fontWeight : bold ? 700 : 400};

  ${baseFontStyles}

  font-size: ${({ mobileSize }) => sizeToStyles.fontSize[mobileSize ?? 'md']};
  line-height: ${({ mobileSize }) =>
    sizeToStyles.lineHeight[mobileSize ?? 'md']};
  letter-spacing: ${({ mobileSize }) =>
    sizeToStyles.letterSpacing[mobileSize ?? 'md']};

  @media (min-width: 900px) {
    font-size: ${({ desktopSize, mobileSize }) =>
      sizeToStyles.fontSize[desktopSize ?? mobileSize ?? 'md']};
    line-height: ${({ desktopSize, mobileSize }) =>
      sizeToStyles.lineHeight[desktopSize ?? mobileSize ?? 'md']};
    letter-spacing: ${({ desktopSize, mobileSize }) =>
      sizeToStyles.letterSpacing[desktopSize ?? mobileSize ?? 'md']};
  }
`;

// Reuse shared styles for different components
export const StyledCocoSharpText = sharedStyles.withComponent('p');
export const StyledCocoSharpInput = styled(sharedStyles.withComponent('input'))`
  &::placeholder {
    color: var(--color-secondary-70);
    opacity: 1; /* Firefox */
  }

  &[type='date'] {
    /* INFO - Firefox <input type="date" /> color fix */
    @supports (-moz-appearance: none) {
      &:not(:valid):not(:focus) {
        color: var(--color-secondary-50) !important;
      }
    }

    &::-webkit-calendar-picker-indicator {
      opacity: 0;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      cursor: pointer;
    }

    &::after {
      content: '';
      position: absolute;
      right: var(--spacing-8);
      top: 50%;
      transform: translateY(-50%);
      width: 20px;
      height: 20px;
      background-image: url('/m/calendar.svg');
      background-size: contain;
      background-repeat: no-repeat;
      pointer-events: none;
    }

    ${(props) =>
      props.placeholder
        ? `&:not(:valid):not(:focus) {
            color: transparent;
          }
          &:not(:valid):not(:focus)::before {
            content: '${props.placeholder}';
            position: absolute;
            left: var(--spacing-8);
            top: 50%;
            transform: translateY(-50%);
            color: var(--color-secondary-70);
          }`
        : `&:not(:valid):not(:focus) {
            color: var(--color-secondary-70);
          }`}

    &:valid {
      color: var(--color-secondary-0);
    }
  }
`;
